import { ApolloQueryResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { getProductQuery } from 'lib/core/services/magento/queries/productQuery'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface WishlistQueryObject {
  wishlist: {
    items_count: boolean
    name: boolean
    sharing_code: boolean
    updated_at: boolean
    items: {
      id: boolean
      qty: boolean
      description: boolean
    }
  }
}

export const wishlistQueryObject: WishlistQueryObject = {
  wishlist: {
    items_count: true,
    name: true,
    sharing_code: true,
    updated_at: true,
    items: {
      id: true,
      qty: true,
      description: true
    }
  }
}

export type GetWishlistQuery = () => Promise<ApolloQueryResult<any>>

export const createWishlistQuery = ({ getQueries }: ServiceDependencies): GetWishlistQuery => async () => {
  const query = getQueries().wishlistQuery
  query.wishlist.items = {
    ...query.wishlist.items,
    ...getProductQuery('product', {
      withBase: true,
      withCustomAttributes: true,
      withReviewSummary: true,
      withOnConfigurable: true
    }, true)
  }

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
